import React from "react";
import { Box, Card, Typography } from "@mui/material";

const ErrorMessageBox = ({ error }) => {
    if (!error) {
        return null;
    }

    return (
        <Box display="flex" justifyContent="center" sx={{ marginBottom: 2 }}>
            <Card sx={{ backgroundColor: "#e74c3c" }} className="py-2 w-full px-4 ">
                <Typography variant="h6" sx={{ fontSize: 14 }} style={{ color: "white" }}>
                    {error}
                </Typography>
            </Card>
        </Box>
    );
};

export default ErrorMessageBox;
